import React, { useContext, useEffect, useState } from "react";
import { APP_FLOW_MENU, APP_MENU, APP_PERMS, TOKEN_NAME } from "../constants/token.const";
import { ApiService } from "@/service/ApiService";
import { GetCookie } from "@/service/CookieService";
import { LoadingSpin } from "@/components/features";
import toast, { Toaster } from "react-hot-toast";
import useLoading from "@/components/features/hooks/useLoading";
import { isMobileUI } from "@/lib/platform";

const AuthContext = React.createContext();

export const formatError = (err) => {
    if (typeof err === "string") return err;
    if (err.data) {
        if (typeof err.data.response === "string") return err.data.response;
        return err.data.response_code;
    }
    return err.statusText;
};

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const { showLoading } = useLoading();
    const [auth, setAuth] = useState({ user: null, loading: true, server_ip: '', txn_date: '' });
    const [isAdminMenu, setIsAdminMenu] = useState(false);
    const [isInstAdmin, setIsInstAdmin] = useState(false);

    function isAuth() {
        if (auth && Object.keys(auth).length === 0) {
            return false;
        }
        return true;
    }

    function onAdminMenuToggle() {
        setIsAdminMenu(!isAdminMenu);
    }

    const api = async (processCode, data, config = {}) => {
        showLoading(true);
        const res = await ApiService(processCode, data, config)
            .then((res) => {
                if (res.status === "error") {
                    return Promise.reject(res);
                }
                return res;
            })
            .catch((err) => {
                if (err.status === 401) {
                    // redirectTo("login");
                }
                toast.error(<div dangerouslySetInnerHTML={{ __html: err }}></div>);
                // return Promise.reject(err.response);
            })
            .finally(() => showLoading(false));
        return res;
    };

    const getMenu = () => {
        let data = JSON.parse(sessionStorage.getItem(APP_MENU) ?? "");
        let menuArr = [];
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                menuArr.push(data[key]);
            }
        }
        return menuArr;
    };

    const getFlowMenu = () => {
        return JSON.parse(sessionStorage.getItem(APP_FLOW_MENU));
    };

    const checkPerm = (pc) => {
        let data = JSON.parse(sessionStorage.getItem(APP_PERMS));
        let res = false;
        data.forEach((item) => {
            if (item.processcode === pc) {
                res = true;
            }
        });
        return res;
    };

    const value = {
        api,
        auth,
        isAuth,
        setAuth,
        getMenu,
        getFlowMenu,
        checkPerm,
        onAdminMenuToggle,
        isAdminMenu,
        isInstAdmin,
        setIsInstAdmin,
    };

    useEffect(() => {
        async function checkUser() {
            if (GetCookie(TOKEN_NAME) === undefined || GetCookie(TOKEN_NAME) === null || GetCookie(TOKEN_NAME) === "") {
                setAuth({});
                return;
            }
            const res = await api("gp000003", {});
            if (res && res?.status !== 'error' && res?.response_code !== 'RC000000') {
                setAuth(res);
                localStorage.setItem('ME_LOGINUSER', res.user.userid);
                if (res.user.menus && res.user.menus.hasOwnProperty('ad') && res.user.menus.ad.submenus.length > 0) {
                    setIsInstAdmin(true);
                } else {
                    setIsInstAdmin(false);
                }
                sessionStorage.setItem(APP_MENU, JSON.stringify(res.user.menus))
                sessionStorage.setItem(APP_FLOW_MENU, JSON.stringify(res.user.flowmenus))
                sessionStorage.setItem(APP_PERMS, JSON.stringify(res.user.perms))
            } else {
                setAuth({})
            }
        }

        checkUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <AuthContext.Provider value={value}>
        {auth?.loading ? <LoadingSpin /> : children}
        <Toaster
            position="top-center"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            // Мобайлд Dynamic Island / AppBar-ын доогуур орохоос сэргийлнэ.
            containerStyle={
                isMobileUI() ? { top: "calc(env(safe-area-inset-top) + 60px)" } : {}
            }
            toastOptions={{
                // Define default options
                className: "",
                duration: 5000,
                style: {
                    background: "#FFF",
                    color: "#363636",
                },
                success: {
                    icon: "👏",
                    duration: 5000,
                    theme: {
                        primary: "green",
                        secondary: "black",
                    },
                    style: {
                        background: "#72c772",
                        color: "#FFF",
                    },
                },
                error: {
                    icon: "🤔",
                    duration: 5000,
                    style: {
                        background: "#fd5050",
                        color: "#FFF",
                    },
                    theme: {
                        primary: "red",
                        secondary: "black",
                    },
                },
            }} />
    </AuthContext.Provider>;
}

export default AuthContext;
